import { useTranslation } from "react-i18next";
import { useTheme } from "../../../context/ThemeContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";

export default function EmptyChatState() {
  const { t } = useTranslation("support");
  const { isDarkMode } = useTheme();

  return (
    <div className="h-full min-h-0 flex-1 flex flex-col items-center justify-center px-8">
      <div
        className={`w-20 h-20 rounded-full flex items-center justify-center mb-6 ${
          isDarkMode ? "bg-dark-surface" : "bg-gray-100"
        }`}
      >
        <FontAwesomeIcon
          icon={faComments}
          className={`text-3xl ${isDarkMode ? "text-gray-500" : "text-gray-400"}`}
        />
      </div>
      <h3
        className={`text-lg font-semibold mb-2 ${
          isDarkMode ? "text-white" : "text-gray-900"
        }`}
      >
        {t("chat.emptyTitle")}
      </h3>
      <p
        className={`text-sm text-center max-w-sm ${
          isDarkMode ? "text-gray-400" : "text-gray-500"
        }`}
      >
        {t("chat.emptyDescription")}
      </p>
    </div>
  );
}
